import React from "react";
import { Form, DatePicker } from "antd";
import { dateParser, DATE_FORMAT, DATE_DATA_FORMAT } from "../../utils/date";

export default ({ placeholder = DATE_FORMAT, defaultDate = null, ...props }) => (
  <Form.Item
    getValueProps={dateParser}
    getValueFromEvent={(momentValue) => momentValue?.format(DATE_DATA_FORMAT)}
    {...props}
  >
    <DatePicker
      format={[DATE_FORMAT, DATE_DATA_FORMAT]}
      placeholder={placeholder}
      defaultPickerValue={defaultDate}
      style={{ width: "100%" }}
    />
  </Form.Item>
);
